/* eslint-disable no-console */
/* eslint-disable complexity */
import { Dropdown, Menu, Modal, Tooltip, message as toast } from "antd";
import React, { useCallback, useEffect, useState, useContext, useMemo } from "react";
import "./index.less";
import { useTranslation } from "react-i18next";
import { FocusSDK, isBjme, isFocusEnv } from "@/utils";
import log from "@/utils/logger";
import { connect } from "dvajs";
import ChatState from "@/types/chat/State";
import Session from "@jd/jdee.im.sdk/lib/es/model/Session";
import SessionType from "@jd/jdee.im.sdk/lib/es/enum/SessionType";
import IconFont from "@/components/icon";
import Employee, { EmployeeAttribute } from "@jd/jdee.im.sdk/lib/es/model/Employee";
import {
  getSessionIndex,
  isCrossPlatformGroupSession,
  isEqualEmployee,
  isOuterContacts
} from "@/utils/chat/message";
import config, { ChatConfig, ConfigEnum, getNetCheckUrl } from "@/config/config";
import { getGroupMemberList, getProjectDetail } from "@/api/chat";
import { ChatMessage, Group } from "@/types/chat";
import { checkScheduleVisible, checkTaskVisible, checkRemindVisible } from "@/utils/chat/group";
import { openCreateSchedule, openCreateRemind, isChatPage } from "@/utils/chat/index";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import bus from "@/utils/bus";
import { buildPagePathKey } from "@/components/Modals/JoyspaceFileSelectorModal/utils";
import { PageType } from "@/components/Joyspace/const";
import { useHandleSessionTypeClick } from "@/components/chat/Session/common";
import prompt from "@/baseComponents/ModalComponent/prompt";
import { analysisLog } from "@/utils/logAnalytics";
import { duccConfigI18 } from "@/utils/i18n";
import colors from "@/components/styles/colors";
import ConnectState from "@jd/jdee.im.sdk/lib/es/enum/ConnectState";
import i18n from "@/i18n";
import NetworkCheck, { UseCheckType } from "@/utils/NetworkCheck";
import useShareUserCardInChat from "@/components/Modals/shareUserCardInChat";
import { UserModel } from "@/models/user";
import { useHistory } from "react-router-dom";
import { groupCreates } from "@/components/Joyspace/api";
import ChatContext from "@/components/chat/context";
import { crossAppSwitch } from "@/utils/tools";

const netServer = NetworkCheck.getInstance({
  url: getNetCheckUrl(),
  checkType: UseCheckType.API
});

const logger = log.getLogger("chat.Input.MoreDropdown");

// eslint-disable-next-line complexity
function MoreDropdown({
  children,
  uploadFile,
  // handleUploadImgs,
  selectedSession,
  sendJoyspaceMessage,
  closeOtherModal,
  currentEmployee,
  openCreateModal,
  openCreateRemindModal,
  launchSingleSession,
  initSelectedSession,
  allSessionList,
  changeSelectMore,
  updateMessages,
  connectState,
  userData
}: {
  children: any;
  uploadFile: (file: any) => void;
  selectedSession: Session;
  sendJoyspaceMessage: (data: any[]) => void;
  closeOtherModal: () => void;
  currentEmployee: Employee;
  connectState: any;
  openCreateModal: Function;
  openCreateRemindModal: Function;
  // handleUploadImgs: Function;
  launchSingleSession: Function;
  initSelectedSession: Function;
  allSessionList: Session[];
  changeSelectMore: Function;
  updateMessages: (data: { messages: ChatMessage[] }) => void;
  userData: UserModel;
}) {
  const [t] = useTranslation("chat");
  const history = useHistory();
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [tooltipVisible, settooltipVisible] = useState(false);
  const [snapChatSessionVisible, setSnapChatSessionVisible] = useState(false);
  const isOutApp = selectedSession.isGroup
    ? isCrossPlatformGroupSession(selectedSession)
    : isOuterContacts(selectedSession, currentEmployee);
  const { groupRosters } = React.useContext(ChatContext);
  const {
    appRuntimeEnv: { joyspaceHost },
    focusSDK
  } = useContext(GlobalContext);
  const { appRuntimeEnv, authInfo } = useContext<GlobalContextConfig>(GlobalContext);
  const shareUserCard = useShareUserCardInChat({
    currentEmployee,
    selectedSession,
    userData
  });
  // 打开创建日程
  async function handleScheduleClick() {
    const params: any = {
      title: "",
      selectedSession: selectedSession
    };
    if (selectedSession.isGroup) {
      const { businessId, business } = selectedSession.info as Group;
      if (business && business?.indexOf("project") > -1) {
        // 专班群
        const [data, error] = await getProjectDetail({
          projectId: businessId,
          summary: true
        });
        if (data?.calendarId) {
          if (isFocusEnv()) {
            openCreateSchedule({
              calendarId: data.calendarId,
              ...params
            });
          } else {
            openCreateModal({
              visible: true,
              frozenCalendarId: data.calendarId,
              ...params
            });
          }
          return;
        }
      }
    }
    if (selectedSession.isSingle) {
      const {
        app,
        userId,
        teamId,
        labelInfoList,
        name: realName,
        avatar,
        employeeExt,
        unitName,
        deptName,
        titleName
      } = selectedSession.info as Employee;
      params.participant = [
        {
          app,
          ddAppId: app,
          userId,
          teamId,
          realName,
          headImg: avatar,
          labelInfoList,
          titleName: `${unitName ? unitName + "-" : ""}${deptName ? deptName + "-" : ""}${
            titleName || ""
          }`,
          userType: employeeExt?.userType
        }
      ];
    }
    if (isFocusEnv()) {
      openCreateSchedule({
        calendarId: "",
        ...params
      });
    } else {
      openCreateModal({
        visible: true,
        frozenCalendarId: "",
        ...params
      });
    }
  }
  // 打开创建任务
  async function handleTaskClick() {
    const onLine = await netServer.checkNet();
    if (!onLine) {
      toast.error(i18n.t("Network Error"));
    }
    if (selectedSession.isGroup) {
      const { businessId, business, name } = selectedSession.info as Group;
      if (business && business?.indexOf("project") > -1) {
        bus.emit("task:open-create", {
          title: "",
          projectId: businessId,
          sourceName: name,
          selectedSession
        });
        return;
      }
    }
    bus.emit("task:open-create", {
      title: "",
      projectId: "",
      sourceName: "",
      selectedSession
    });
    // }
  }
  // 打开创建提醒
  async function handleRemindClick() {
    // console.log(selectedSession, 'selectedSessionselectedSessionselectedSession');
    if (isFocusEnv()) {
      openCreateRemind({
        selectedSession: selectedSession,
        createData: {
          from: "IM"
        }
      });
    } else {
      openCreateRemindModal({
        visible: true,
        selectedSession: selectedSession,
        createData: {
          from: "IM"
        }
      });
    }
  }
  // 打开组接龙
  function handleSolitaireClick() {
    FocusSDK.emit("openCreateSolitaire", { visible: true, currentEmployee });
  }
  // 选择文档后上报
  const exportJoyspaceLog = (list: any[]) => {
    let types: any[] = [];
    let ids: any[] = [];
    list.forEach((item: any) => {
      types.push(item.pageType || item.type);
      ids.push(item.id);
    });
    analysisLog(
      "xtbg_jzb_joysapce_inOtherModule_1676971574856",
      "18",
      types.join("/"),
      ids.join("/")
    );
  };

  // 生成URL
  const caertJoySpaceLink = useCallback(
    (data: any) => {
      let content;
      if (data.pageType === PageType.Form) {
        // 低代码
        content = data.link;
        return content;
      }
      const { joyspaceHost } = appRuntimeEnv;
      const path = buildPagePathKey(data.pageType).subPath;
      const link = `${joyspaceHost}/${path}/${data.id}`;
      return `${link}`;
    },
    [appRuntimeEnv]
  );
  const callback = useCallback(
    ({
      status,
      callbackId,
      results
    }: {
      status: "ok" | "cancel";
      callbackId: string;
      results: any;
    }) => {
      console.log("callbacktest:chat", callbackId);
      const { sessionId } = selectedSession;
      if (selectedSession.sessionId !== callbackId) {
        return;
      }

      if (status === "cancel") {
        return;
      }
      if (results.length === 0) {
        return;
      }
      const list = results.map((item: any) => {
        return {
          content: "",
          icon: item.icon,
          title: item.title,
          type: item.type,
          pageType: item.pageType,
          id: item.id,
          permissionType: item.permissionType,
          url: caertJoySpaceLink(item),
          from: item.from
        };
      });
      // 选择文档完成后上报日志
      exportJoyspaceLog(list);
      sendJoyspaceMessage(list);
    },
    [selectedSession, sendJoyspaceMessage, caertJoySpaceLink]
  );
  const canOpenSnaptChat = useMemo(() => {
    if (selectedSession.isGroup || selectedSession.isNotice || selectedSession.isSecret) {
      return false;
    }
    const info = selectedSession.info as Employee;
    if (isEqualEmployee(info, currentEmployee)) {
      return false;
    }
    return true;
  }, [selectedSession, currentEmployee]);
  // 打开文档
  const handleJoySpaceClick = useCallback(() => {
    if (isFocusEnv()) {
      logger.debug("handleJoySpaceClick", selectedSession, currentEmployee);
      const { sessionType, sessionId, info } = selectedSession;
      let pin = sessionId;
      let teamId = "";
      let app = "";
      if (sessionType === SessionType.SINGLE || sessionType === SessionType.SECRET_SINGLE) {
        const employee = info as EmployeeAttribute;
        if (!employee) {
          logger.error("handleJoySpaceClick can not get uid", { sessionType });
          return;
        }
        pin = employee.userId;
        teamId = employee.teamId;
        app = employee.app;
      }
      if (sessionType === SessionType.GROUP) {
        teamId = currentEmployee.teamId;
        app = currentEmployee.app;
      }
      // FocusSDK.once("openJoyspaceDocSelector:result", callback);
      FocusSDK.emit("openJoyspaceDocSelector", { callbackId: selectedSession.sessionId, callback });
      // FocusSDK.shareDocuments(
      //     {
      //         pin,
      //         sessionType,
      //         teamId,
      //         app,
      //     },
      //     (data: any) => {
      //         logger.debug('shareDocuments result', data);
      //         sendJoyspaceMessage(data);
      //     }
      // );
    } else {
      focusSDK.emit("openJoyspaceCloudSelector", {
        callbackId: "chat-cloud-file",
        callback: (data: any) => {
          console.log("data---", data);
          const { joyspaceApiHost } = appRuntimeEnv;
          const list = data.map((item: any) => {
            return {
              ...item,
              content: "",
              url: caertJoySpaceLink(item)
            };
          });
          // 文档选择完成后上报
          exportJoyspaceLog(list);
          sendJoyspaceMessage(list);
        }
      });
    }
  }, [callback]);

  // 创建组空间
  const groupCreate = useCallback(async () => {
    const owner = (selectedSession as any)?.info || {};
    const { gid } = owner;
    const gname = owner.name;
    const description = owner.intro;

    const onLine = await netServer.checkNet();
    if (!onLine) {
      toast.error(i18n.t("Network Error"));
      return;
    }
    let groupList = groupRosters;
    try {
      if (Array.isArray(groupList) && !groupList.length) {
        const { data } = await getGroupMemberList(gid, "group");
        groupList = data || [];
      }
      console.log("群组信息", groupList);
      if (!groupList.length) {
        toast.error("该群已解散");
        // return;
      }

      let admins: any = [];
      for (let item of groupList) {
        if (item.identity === "administrator" || item.identity === "sub_administrator") {
          admins.push((item as any).info.userId);
        }
      }
      let result = await groupCreates({
        admins,
        folderId: gid,
        name: gname,
        description,
        parent: "groupRoot"
      });
      if (!result || result.errMsg) {
        toast.error("create_group_team_space_error");
      }
    } catch (e) {
      console.error(e, "=asdadadasdadasdad");
      e && toast.error(e);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSession, groupRosters, t]);

  // 打开组空间
  const handleGroupSpace = useCallback(() => {
    groupCreate().then(() => {
      if (isFocusEnv()) {
        logger.debug("handleGroupSpace", selectedSession, currentEmployee);
        const { sessionId } = selectedSession;

        // FocusSDK.once("openJoyspaceDocSelector:result", callback);
        FocusSDK.emit("openJoyspaceDocSelector", {
          callbackId: sessionId,
          groupInfo: { gid: (selectedSession as any)?.info.gid },
          callback
        });
      } else {
        focusSDK.emit("openJoyspaceCloudSelector", {
          callbackId: "chat-groupspace-file",
          groupInfo: {
            gid: (selectedSession as any)?.info.gid
          },
          callback: (data: any) => {
            console.log("data---", data);
            const list = data.map((item: any) => {
              return {
                ...item,
                content: "",
                url: caertJoySpaceLink(item),
                from: item.from
              };
            });
            // 文档选择完成后上报
            exportJoyspaceLog(list);
            sendJoyspaceMessage(list);
          }
        });
      }
    });
  }, [callback, selectedSession]);

  function handleFileClick() {
    const input = document.createElement("INPUT");
    document.body.appendChild(input);
    input.setAttribute("type", "file");
    input.setAttribute("multiple", "true");
    input.onchange = (ev: any) => {
      if (ev.target.files && ev.target.files.length > 0) {
        uploadFile(ev.target.files);
      }
    };
    input.click();
    document.body.removeChild(input);
    // input.remove();
  }

  // 打开组通知
  function handleGroupNotClick() {
    if (selectedSession.isGroup) {
      let visible = true;
      FocusSDK.emit("openGroupNotClick", {
        selectedSession: selectedSession,
        visible: visible
      });
    }
  }
  function dropdownVisibleChange(visible: boolean) {
    // 点击+号 关闭常用语和@modal
    closeOtherModal();
    if (visible) {
      analysisLog("Xtbg_Msg_Info_MsgDialog", "MoreService");
      settooltipVisible(false);
    }
    setDropdownVisible(visible);
  }
  function tooltipVisibleChange(visible: boolean) {
    if (dropdownVisible && visible) {
      return;
    }
    settooltipVisible(visible);
  }

  function findSnapChatSession() {
    const index = getSessionIndex(allSessionList, {
      sessionId: `${selectedSession.sessionId}:secret`
    });
    return index > -1;
  }

  const openConfirmModal = () => {
    const isExistInSessionList = findSnapChatSession();
    if (isExistInSessionList) {
      prompt({
        title: t("change-session.secret-chat-title"),
        icon: <IconFont type="iconic_failure" style={{ color: "#F96137" }} />,
        onOk: async () => {
          handleChangeSession();
        },
        content: t("change-session.secret-chat-content"),
        okText: t("determine"),
        cancelText: t("cancelText")
      });
    } else {
      setSnapChatSessionVisible(true);
    }
  };

  const handleChangeSession = useHandleSessionTypeClick({
    selectedSession,
    launchSingleSession,
    initSelectedSession,
    updateMessages,
    changeSelectMore,
    closeConfirmModal: () => setSnapChatSessionVisible(false),
    history
  });

  function handleShareCardClick() {
    return shareUserCard();
  }

  const menu = (
    <Menu className="chat-input-more-menu">
      {config[ChatConfig.CHAT_MESSAGE_INPUT_FILE] && (
        <Menu.Item
          onClick={handleFileClick}
          clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|UploadDoc"
        >
          <div className="more-menu-operate-item">
            <IconFont
              className="chat-input-more-menu-icon iconic_app_more_file"
              type="iconic_app_more_file"
            />
            <span className="menu-text">{isBjme() ? t("local-file") : t("file")}</span>
          </div>
        </Menu.Item>
      )}
      {!selectedSession.isSecret &&
        config[ChatConfig.CHAT_MESSAGE_INPUT_JOYSPACE] &&
        !isOutApp &&
        ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(selectedSession?.sessionType) &&
        // 解决移动端基于日程创建的群组，在pc端没有云文件入口的bug
        !(
          selectedSession.isSingle &&
          (selectedSession.info as EmployeeAttribute)?.app !== currentEmployee.app
        ) && (
          <Menu.Item
            onClick={handleJoySpaceClick}
            clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|CloudDoc"
          >
            <div className="more-menu-operate-item">
              <IconFont
                className="chat-input-more-menu-icon iconic_app_more_cloudspace"
                type="iconic_app_more_cloudspace"
              />
              <span className="menu-text">
                {t("cloud-space", {
                  joyspace: duccConfigI18.joyspace
                })}
              </span>
            </div>
          </Menu.Item>
        )}
      {selectedSession.isGroup &&
        config[ChatConfig.CHAT_MESSAGE_INPUT_GROUP_SPACE] &&
        !isOutApp &&
        ![SessionType.MEETING_GROUP].includes(selectedSession?.sessionType) && (
          <Menu.Item onClick={handleGroupSpace}>
            <div className="more-menu-operate-item">
              <IconFont
                className="chat-input-more-menu-icon iconic_app_more_cloudspace"
                type="iconzukongjian"
              />
              <span className="menu-text">{t("groupSpace")}</span>
            </div>
          </Menu.Item>
        )}
      {!selectedSession.isSecret &&
        crossAppSwitch("joywork", currentEmployee, appRuntimeEnv) &&
        checkTaskVisible({ selectedSession }) &&
        !isOutApp &&
        ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(selectedSession?.sessionType) &&
        config[ConfigEnum.EXTERNAL_CONTACTS_CREAT_TASK] && (
          <Menu.Item
            onClick={handleTaskClick}
            clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|Task"
          >
            <div className="more-menu-operate-item">
              <IconFont
                className="chat-input-more-menu-icon iconic_app_more_task"
                type="iconic_app_more_task"
              />
              <span className="menu-text">{t("task_distribution")}</span>
            </div>
          </Menu.Item>
        )}
      {!selectedSession.isSecret &&
        config[ChatConfig.CHAT_MESSAGE_INPUT_SCHEDULE] &&
        ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(selectedSession?.sessionType) &&
        checkScheduleVisible({ selectedSession }) && (
          <Menu.Item
            onClick={handleScheduleClick}
            clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|Schedule"
          >
            <div className="more-menu-operate-item">
              <IconFont
                className="chat-input-more-menu-icon iconic_app_more_schedule"
                type="iconic_app_more_schedule"
              />
              <span className="menu-text">{t("schedule_share")}</span>
            </div>
          </Menu.Item>
        )}
      {!selectedSession.isSecret &&
        config[ChatConfig.CHAT_MESSAGE_INPUT_REMIND] &&
        !isOutApp &&
        ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(selectedSession?.sessionType) &&
        checkRemindVisible({ selectedSession }) && (
          <Menu.Item
            onClick={handleRemindClick}
            clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|Urge"
          >
            <div className="more-menu-operate-item">
              <IconFont
                className="chat-input-more-menu-icon iconic_app_more_remind"
                type="iconic_app_more_remind"
              />
              <span className="menu-text">{t("warn")}</span>
            </div>
          </Menu.Item>
        )}

      {currentEmployee?.teamId !== appRuntimeEnv?.bjwpConfig?.teamId &&
        checkRemindVisible({ selectedSession }) &&
        !isOutApp &&
        ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(selectedSession?.sessionType) &&
        selectedSession.isGroup && (
          <Menu.Item
            onClick={handleGroupNotClick}
            clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|GroupNotice"
          >
            <div className="more-menu-operate-item">
              <IconFont
                // style={{ verticalAlign: 'middle' }}
                className="chat-input-more-menu-icon iconic_app_more_notification"
                type="iconic_app_more_notification"
              />
              <span className="menu-text">{t("group_tz")}</span>
            </div>
          </Menu.Item>
        )}

      {/* 组接龙 */}
      {config[ChatConfig.CHAT_MESSAGE_INPUT_SOLITAIRE] &&
        checkRemindVisible({ selectedSession }) &&
        !isOutApp &&
        ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(selectedSession?.sessionType) &&
        selectedSession.isGroup === true && (
          <Menu.Item onClick={handleSolitaireClick}>
            <div className="more-menu-operate-item">
              <IconFont
                style={{ color: `${colors.primary2}` }}
                className="chat-input-more-menu-icon iconapp_btn_schedule"
                type="iconic_app_btn_groupsolitaire1"
                clstag="pageclick|keycount|focus_chat_01_1602584371145|47"
              />
              <span className="menu-text">{t("solitaire")}</span>
            </div>
          </Menu.Item>
        )}

      {/* 单聊且不是密聊and是好友关系and不是和自己聊天 */}
      {canOpenSnaptChat &&
        !isOutApp &&
        !isChatPage() &&
        ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(selectedSession?.sessionType) &&
        config[ChatConfig.CHAT_MESSAGE_INPUT_SNAPCHAT] && (
          <Menu.Item
            onClick={() => openConfirmModal()}
            clstag="pageclick|keycount|Xtbg_Msg_Info_MsgDialog|SnapChat"
          >
            <div className="more-menu-operate-item">
              <IconFont
                className="chat-input-more-menu-icon iconic_app_im_rurn_after_reading burnafterreading_facet"
                type="iconic_app_im_burnafterreading_facet"
              />
              <span className="menu-text">{t("snapchat")}</span>
            </div>
          </Menu.Item>
        )}
      {/* 个人名片 */}
      {config[ChatConfig.CHAT_MESSAGE_INPUT_SHARE_CARD] &&
        ![SessionType.MEETING_GROUP, SessionType.LIVE_MEETING_GROUP].includes(selectedSession?.sessionType) &&
        !selectedSession.isSecret && (
          <Menu.Item onClick={handleShareCardClick}>
            <div className="more-menu-operate-item">
              <IconFont
                className="chat-input-more-menu-icon iconic_app_more_file"
                type="iconic_app_businesscard"
              />
              <span className="menu-text">{t("share_card")}</span>
            </div>
          </Menu.Item>
        )}
    </Menu>
  );

  const snapChatSessionTitle = (
    <div>
      <IconFont type="iconic_failure" style={{ color: "#F96137" }} />
      <span style={{ marginLeft: 6 }}>提示</span>
    </div>
  );

  return (
    <>
      <Dropdown
        placement="topCenter"
        overlay={menu}
        className="chat-input-more-dropdown"
        onVisibleChange={dropdownVisibleChange}
        trigger={["click"]}
        overlayClassName="more-dropdown"
      >
        {/* <Tooltip
                    overlayClassName="chat-input-more-dropdown-tip"
                    title={t('more')}
                    visible={true}
                    onVisibleChange={tooltipVisibleChange}
                    placement="top"
                > */}
        {children}
        {/* </Tooltip> */}
      </Dropdown>
      <Modal
        visible={snapChatSessionVisible}
        width={360}
        title={snapChatSessionTitle}
        okText={t("button.ok")}
        cancelText={t("button.cancel")}
        wrapClassName="snapChatSessionModal"
        centered={true}
        destroyOnClose={true}
        maskClosable={false}
        onCancel={() => setSnapChatSessionVisible(false)}
        onOk={() => {
          handleChangeSession();
        }}
      >
        <div className="snapChatSessionContent">
          <h4>{t("change-session.snap-chat-title")}</h4>
          <p>
            <span>*</span>
            {t("change-session.snap-chat-content")}
          </p>
        </div>
      </Modal>
    </>
  );
}

function mapStateToProps({ user, chat }: { user: any; chat: ChatState }) {
  const { selectedSession, currentEmployee, allSessionList, connectState } = chat as ChatState;
  // eslint-disable-next-line prettier/prettier
  return {
    selectedSession,
    currentEmployee,
    allSessionList,
    connectState,
    userData: user.userData ? user.userData.user : {}
  };
}

function mapDispatchToProps(dispatch: any) {
  return {
    openCreateModal(data: any) {
      dispatch({ type: "calendar/openCreateModal", payload: data });
    },
    openCreateRemindModal(data: any) {
      dispatch({ type: "supervise/setCreateModalVisible", payload: data });
    },
    launchSingleSession(data: { employee: Employee }) {
      dispatch({ type: "chat/launchSingleSession", payload: data });
    },
    initSelectedSession(data: { selectedSession: Session }) {
      dispatch({ type: "chat/initSelectedSession", payload: data });
    },
    updateMessages(data: { messages: ChatMessage[] }) {
      dispatch({ type: "chat/updateMessages", payload: data });
    },
    changeSelectMore(data: { selectMore: boolean }) {
      dispatch({ type: "chat/changeSelectMore", payload: data });
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MoreDropdown);
